import { formatDateHuman, parseDateRaw } from "../date-utils";
export const slaughterDtoFields = [{
        /*
          name: "protocol",
          title: "Protocollo",
          render: (record: ISlaughterDTO) => record.slaughter.protocol
        }, {
        */
        name: "slaughterDate",
        title: "Data",
        render: (record) => formatDateHuman(parseDateRaw(record.slaughter.slaughterDate))
    }, {
        name: "dailyNumber",
        title: "Num.Prog.",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.slaughter.dailyNumber
    }, {
        name: "srcCod317",
        title: "Cod.317",
        render: (record) => record.slaughter.srcCod317
    }, {
        name: "srcCustomerName",
        title: "Provenienza",
        render: (record) => record.srcCustomerName
    }, {
        name: "dstCustomerName",
        title: "Destinazione",
        render: (record) => record.dstCustomerName
    }, {
        name: "purposeDescription",
        title: "Scopo",
        render: (record) => record.purposeDescription
        /*
        }, {
          name: "roomTypeDescription",
          title: "Stoccaggio",
          render: (record: ISlaughterDTO) => record.roomTypeDescription
        */
    }, {
        name: "totQuantity",
        title: "Num.Capi",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.slaughter.totQuantity
    }, {
        name: "working",
        title: "Lavorazione",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.slaughter.working === 1 ? "check" : ""}</i>`
    }, {
        name: "completed",
        title: "Completato",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => `<i class="material-icons">${record.slaughter.completed === 1 ? "check" : ""}</i>`
        /*
        }, {
          name: "active",
          title: "Attiva",
          titleClass: "has-text-centered",
          dataClass: "has-text-centered",
          render: (record: ISlaughterDTO) => `<i class="material-icons">${record.slaughter.active === 1 ? "check" : "close"}</i>`
        */
    }];
